(function () {
  'use strict';
  var mq = function (q) { return window.matchMedia && window.matchMedia(q).matches; };
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var finePointer = mq('(hover: hover) and (pointer: fine)');
  var small = mq('(max-width: 700px)');
  var raf = window.requestAnimationFrame.bind(window);

  /* ---------- Intro : on la retire une fois jouée ---------- */
  var intro = document.querySelector('.z-intro');
  if (intro) setTimeout(function () { intro.remove(); }, 2200);

  /* ---------- Titres découpés en mots qui pivotent ---------- */
  document.querySelectorAll('.scene h1, .coll-hero h1').forEach(function (h) {
    if (reduce || h.classList.contains('is-split')) return;
    var words = h.textContent.trim().split(/\s+/);
    h.innerHTML = words.map(function (w, i) {
      var d = document.createElement('span'); d.textContent = w;
      return '<span class="w" style="--wi:' + i + '">' + d.innerHTML + '</span>';
    }).join(' ');
    h.classList.add('is-split');
  });

  /* ---------- Sections qui arrivent en 3D ---------- */
  if (!reduce && 'IntersectionObserver' in window) {
    var secs = Array.prototype.slice.call(document.querySelectorAll('main .shopify-section')).slice(1);
    var sio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); sio.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
    secs.forEach(function (s) {
      var r = s.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) return;
      s.classList.add('z-sec'); sio.observe(s);
    });
  }

  /* ---------- Compteur du nombre de produits ---------- */
  document.querySelectorAll('.coll-hero .count').forEach(function (el) {
    var m = el.textContent.match(/^(\d+)(.*)$/);
    if (!m || reduce) return;
    var to = parseInt(m[1], 10), rest = m[2];
    el.innerHTML = '<span class="n">0</span>' + rest;
    var n = el.querySelector('.n'), t0 = null;
    function step(t) { if (!t0) t0 = t; var k = Math.min(1, (t - t0) / 1100); n.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))); if (k < 1) raf(step); }
    setTimeout(function () { raf(step); }, 300);
  });

  /* ---------- Sous-catégories : surbrillance qui suit la souris ---------- */
  document.querySelectorAll('.subcats').forEach(function (ul) {
    Array.prototype.forEach.call(ul.children, function (li, i) { li.style.setProperty('--ci', i); });
    if (!finePointer) return;
    var glow = document.createElement('span'); glow.className = 'subcats__glow'; ul.insertBefore(glow, ul.firstChild);
    ul.addEventListener('pointerover', function (e) {
      var a = e.target.closest('a'); if (!a) return;
      glow.style.width = a.offsetWidth + 'px'; glow.style.height = a.offsetHeight + 'px';
      glow.style.transform = 'translate(' + a.parentNode.offsetLeft + 'px,' + a.parentNode.offsetTop + 'px)';
      glow.style.opacity = a.getAttribute('aria-current') ? '0' : '1';
    });
    ul.addEventListener('pointerleave', function () { glow.style.opacity = '0'; });
  });

  /* ---------- Cartes produit : inclinaison 3D et reflet ---------- */
  if (finePointer && !reduce) {
    document.addEventListener('pointermove', function (e) {
      var card = e.target.closest && e.target.closest('.card');
      if (!card) return;
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      card.style.transitionDelay = '0ms';
      card.style.setProperty('--ry', ((x - 0.5) * 14).toFixed(2) + 'deg');
      card.style.setProperty('--rx', ((0.5 - y) * 10).toFixed(2) + 'deg');
      card.style.setProperty('--gx', (x * 100).toFixed(1) + '%');
      card.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
      card.classList.add('is-tilting');
    }, { passive: true });
    document.addEventListener('pointerout', function (e) {
      var card = e.target.closest && e.target.closest('.card');
      if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
      card.classList.remove('is-tilting');
      card.style.setProperty('--rx', '0deg'); card.style.setProperty('--ry', '0deg');
    });
  }

  /* ---------- Rangées de produits en carrousel 3D ---------- */
  if (!reduce) {
    document.querySelectorAll('.rail').forEach(function (rail) {
      rail.classList.add('is-cf');
      var cards = rail.querySelectorAll('.card');
      var queued = false;
      function paint() {
        queued = false;
        var rr = rail.getBoundingClientRect(), cx = rr.left + rr.width / 2;
        Array.prototype.forEach.call(cards, function (c) {
          var r = c.getBoundingClientRect();
          var d = Math.max(-1, Math.min(1, ((r.left + r.width / 2) - cx) / (rr.width / 2)));
          c.style.setProperty('--cf', (-d * 16).toFixed(2) + 'deg');
          c.style.setProperty('--cfs', (1 - Math.abs(d) * 0.07).toFixed(3));
        });
      }
      function q() { if (!queued) { queued = true; raf(paint); } }
      rail.addEventListener('scroll', q, { passive: true });
      window.addEventListener('resize', q);
      paint();
    });
  }

  /* ---------- Petits animaux posés sur les produits ---------- */
  (function () {
    var types = ['cat', 'bird', 'dog'];
    var budget = small ? 2 : 4, k = 0;
    document.querySelectorAll('.grid[data-reveal], .rail[data-reveal]').forEach(function (box, bi) {
      if (budget <= 0) return;
      var cards = Array.prototype.slice.call(box.querySelectorAll('.card'));
      if (!cards.length) return;
      var top = cards[0].offsetTop;
      var firstRow = cards.filter(function (c) { return Math.abs(c.offsetTop - top) < 8; });
      var picks = firstRow.length >= 4 ? [0, 2, 3] : firstRow.length >= 2 ? [0, 1] : [0];
      if (box.classList.contains('rail')) picks = [1, 3, 5];
      var used = 0;
      picks.forEach(function (idx) {
        var card = (box.classList.contains('rail') ? cards : firstRow)[idx];
        if (!card || budget <= 0 || used >= (small ? 1 : 2)) return;
        var type = types[(k + bi) % types.length]; k++;
        var tpl = document.getElementById('z-critter-' + type);
        if (!tpl) return;
        card.appendChild(tpl.content.cloneNode(true));
        card.classList.add('has-critter');
        budget--; used++;
      });
      if (used) box.classList.add('has-critters');
    });
    if (!finePointer) return;
    var pupils = document.querySelectorAll('.critter--dog .d-pupil');
    if (!pupils.length) return;
    document.addEventListener('pointermove', function (e) {
      pupils.forEach(function (p) {
        var r = p.getBoundingClientRect();
        var dx = e.clientX - (r.left + r.width / 2), dy = e.clientY - (r.top + r.height / 2);
        var len = Math.sqrt(dx * dx + dy * dy) || 1;
        p.style.transform = 'translate(' + (dx / len * 2.2).toFixed(2) + 'px,' + (dy / len * 2.2).toFixed(2) + 'px)';
      });
    }, { passive: true });
  })();

  /* ---------- Oiseaux qui traversent l'écran ---------- */
  if (!reduce && document.body.animate) {
    var sky = document.createElement('div'); sky.className = 'z-sky'; sky.setAttribute('aria-hidden', 'true');
    document.body.appendChild(sky);
    var palette = [['#3E8EA8', '#2C6E86', '#BFE3EA'], ['#E07A45', '#B8572F', '#F6D3B8'], ['#F0A93B', '#C98A1E', '#FBE7C2']];
    function flyBird() {
      if (document.hidden) return;
      var c = palette[Math.floor(Math.random() * palette.length)];
      var b = document.createElement('div'); b.className = 'z-sky__bird';
      b.innerHTML = '<svg viewBox="-30 -30 62 46"><path d="M-14,-2 L-28,-8 L-26,4 Z" fill="' + c[1] + '"/><ellipse rx="16" ry="11" fill="' + c[0] + '"/><ellipse cx="2" cy="4" rx="10" ry="6" fill="' + c[2] + '"/><circle cx="14" cy="-6" r="8.5" fill="' + c[0] + '"/><circle cx="17" cy="-8" r="1.8" fill="#1E1E22"/><path d="M22,-6 L30,-4 L22,-2 Z" fill="#F0A93B"/><path class="b-wing" d="M-4,-4 C-2,-28 12,-28 10,-4 Z" fill="' + c[1] + '"/></svg>';
      sky.appendChild(b);
      var w = window.innerWidth, y = 70 + Math.random() * 160, ltr = Math.random() > 0.35, s = 0.6 + Math.random() * 0.5;
      var x0 = ltr ? -60 : w + 60, x1 = ltr ? w + 60 : -60, flip = ltr ? 1 : -1;
      var frames = [];
      for (var i = 0; i <= 8; i++) {
        var t = i / 8;
        frames.push({ transform: 'translate(' + (x0 + (x1 - x0) * t) + 'px,' + (y + Math.sin(t * Math.PI * 3) * 24) + 'px) scale(' + (s * flip) + ',' + s + ')' });
      }
      var a = b.animate(frames, { duration: 7000 + Math.random() * 4000, easing: 'linear' });
      a.onfinish = function () { b.remove(); };
    }
    setTimeout(flyBird, 4000);
    setInterval(flyBird, 16000);
  }

  /* ---------- Traces de pattes derrière le curseur ---------- */
  if (finePointer && !reduce) {
    var lastX = 0, lastY = 0, flip = false;
    var PAW = '<ellipse cx="6.5" cy="14" rx="3" ry="4"/><ellipse cx="12.5" cy="8" rx="3" ry="4.2"/><ellipse cx="19.5" cy="8" rx="3" ry="4.2"/><ellipse cx="25.5" cy="14" rx="3" ry="4"/><path d="M16 15c-5 0-9 4-9 8 0 3 2.5 4 5 3.5 1.5-.3 2.5-.8 4-.8s2.5.5 4 .8c2.5.5 5-.5 5-3.5 0-4-4-8-9-8z"/>';
    document.addEventListener('pointermove', function (e) {
      var dx = e.clientX - lastX, dy = e.clientY - lastY;
      if (dx * dx + dy * dy < 90 * 90) return;
      if (e.target.closest && e.target.closest('input,select,textarea,.z-drawer')) return;
      var ang = Math.atan2(dy, dx) * 180 / Math.PI + 90;
      lastX = e.clientX; lastY = e.clientY; flip = !flip;
      var off = flip ? 7 : -7, rad = (ang) * Math.PI / 180;
      var p = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      p.setAttribute('viewBox', '0 0 32 32'); p.setAttribute('class', 'z-paw-print'); p.setAttribute('aria-hidden', 'true');
      p.innerHTML = PAW;
      p.style.left = (e.clientX + Math.cos(rad) * off) + 'px'; p.style.top = (e.clientY + Math.sin(rad) * off) + 'px';
      p.style.setProperty('--r', ang.toFixed(0) + 'deg');
      document.body.appendChild(p);
      setTimeout(function () { p.remove(); }, 1500);
    }, { passive: true });
  }

  /* ---------- Boutons aimantés ---------- */
  if (finePointer && !reduce) {
    document.querySelectorAll('.btn-cta, .scene__ghost').forEach(function (b) {
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.setProperty('--mx', ((e.clientX - r.left - r.width / 2) * 0.22).toFixed(1) + 'px');
        b.style.setProperty('--my', ((e.clientY - r.top - r.height / 2) * 0.3).toFixed(1) + 'px');
      });
      b.addEventListener('pointerleave', function () { b.style.setProperty('--mx', '0px'); b.style.setProperty('--my', '0px'); });
    });
  }

  /* ---------- Loupe sur la photo produit ---------- */
  var zoomBox = document.querySelector('[data-main-img]');
  if (zoomBox && finePointer) {
    zoomBox.addEventListener('pointermove', function (e) {
      var r = zoomBox.getBoundingClientRect();
      zoomBox.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
      zoomBox.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      zoomBox.classList.add('is-zoom');
    });
    zoomBox.addEventListener('pointerleave', function () { zoomBox.classList.remove('is-zoom'); });
  }

  /* ---------- Le produit s'envole vers le panier ---------- */
  var badge = document.getElementById('cart-count');
  if (badge && !reduce && document.body.animate) {
    var pending = null;
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f.action || f.action.indexOf('/cart/add') === -1) return;
      var card = f.closest('.card');
      var img = card ? card.querySelector('.art img') : document.querySelector('[data-main-img] img');
      pending = img ? { img: img, t: Date.now() } : null;
    }, true);
    new MutationObserver(function () {
      if (!pending || Date.now() - pending.t > 8000) return;
      var img = pending.img; pending = null;
      var a = img.getBoundingClientRect(), b = badge.getBoundingClientRect();
      var size = Math.min(a.width, 160);
      var c = document.createElement('img');
      c.src = img.currentSrc || img.src; c.alt = ''; c.className = 'z-fly';
      c.style.width = size + 'px'; c.style.height = size + 'px';
      c.style.left = (a.left + a.width / 2 - size / 2) + 'px'; c.style.top = (a.top + a.height / 2 - size / 2) + 'px';
      document.body.appendChild(c);
      var dx = (b.left + b.width / 2) - (a.left + a.width / 2), dy = (b.top + b.height / 2) - (a.top + a.height / 2);
      var anim = c.animate([
        { transform: 'translate(0,0) scale(1) rotate(0)', opacity: 1 },
        { transform: 'translate(' + dx * 0.45 + 'px,' + (dy * 0.45 - 140) + 'px) scale(.6) rotate(-12deg)', opacity: 1, offset: 0.5 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.08) rotate(25deg)', opacity: 0.3 }
      ], { duration: 950, easing: 'cubic-bezier(.45,0,.2,1)' });
      anim.onfinish = function () { c.remove(); };
    }).observe(badge, { childList: true, characterData: true, subtree: true });
  }

  /* ---------- Chien qui court dans le pied de page ---------- */
  var strip = document.querySelector('[data-fstrip]');
  if (strip && 'IntersectionObserver' in window && !reduce) {
    new IntersectionObserver(function (en) { strip.classList.toggle('is-on', en[0].isIntersecting); }).observe(strip);
  }

  /* ---------- Profondeur de la scène d'accueil ---------- */
  var scene = document.querySelector('[data-scene]');
  if (scene && !reduce) {
    var layers = scene.querySelectorAll('.layer');
    var mx = 0, my = 0, ticking = false;
    function paintLayers() {
      ticking = false;
      var sy = Math.min(window.scrollY, 900);
      layers.forEach(function (l) {
        var d = parseFloat(l.getAttribute('data-depth')) || 0.2;
        l.style.transform = 'translate(' + (-mx * d * 60).toFixed(1) + 'px,' + (-my * d * 30 + sy * d * 0.35).toFixed(1) + 'px)';
      });
    }
    function q() { if (!ticking) { ticking = true; raf(paintLayers); } }
    if (finePointer) scene.addEventListener('pointermove', function (e) {
      var r = scene.getBoundingClientRect();
      mx = (e.clientX - r.left) / r.width - 0.5; my = (e.clientY - r.top) / r.height - 0.5; q();
    });
    window.addEventListener('scroll', q, { passive: true });
  }
})();
